import { CONSENT_COOKIE } from './constants';
import { setCookie } from 'nookies';

const validConsent = JSON.stringify({
    schemaVersion: 4,
    content: {
        brand: 1,
        consents: [
            {
                apiVersion: 1,
                stored: false,
                date: 'Tue, 19 Apr 2022 10:09:41 GMT',
                categories: [
                    {
                        id: 1,
                        consentGiven: true
                    },
                    {
                        id: 3,
                        consentGiven: true
                    },
                    {
                        id: 4,
                        consentGiven: true
                    }
                ]
            }
        ]
    }
});

export const setPersonalisationConsentCookie = () => {
    setCookie(null, CONSENT_COOKIE, validConsent);
};
